import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const theme = createTheme({
  palette: {
    primary: {
      main: "#253A6A",
      light: "#FFFFFF",
      heading: "#003A70",
      background: "#F9FCFF",
      outerborder: "#EFF4FF99",
    },
    secondary: {
      main: "#00A0E3",
      light: "#E3F7FD",
    },
    // progress: {
    //   main: "rgba(255, 106, 95, 1)",
    //   light: "#FAFDFD",
    // },
  },
  typography: {
    fontFamily: [
      "Roboto",
      "Poppins",
      "Noto Sans Devanagari",
      "Hind",
      "Khand",
      "Teko",
      "Vesper Libre",
      "Arya",
      "Rozha One",
      "Noto Sans Telugu",
      "Dhurjati",
      "Ramabhadra",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiTypography: {
      defaultProps: {
        fontFamily: [
          "Roboto",
          "Poppins",
          "Noto Sans Devanagari",
          "Hind",
          "Khand",
          "Teko",
          "Vesper Libre",
          "Arya",
          "Rozha One",
          "Noto Sans Telugu",
          "Dhurjati",
          "Ramabhadra",
          "sans-serif",
        ].join(","),
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          fontFamily: [
            "Roboto",
            "Poppins",
            "Noto Sans Devanagari",
            "Hind",
            "Khand",
            "Teko",
            "Vesper Libre",
            "Arya",
            "Rozha One",
            "Noto Sans Telugu",
            "Dhurjati",
            "Ramabhadra",
            "sans-serif",
          ].join(","),
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#E5E5E5",
        },
        h4: {
          fontSize: "2rem!important",
          fontWeight: "600!important",
        },
        h2: {
          fontSize: "2.25rem!important",
          fontWeight: "600!important",
        },
        h3: {
          fontSize: "2.125rem!important",
          fontWeight: "600!important",
        },
        a: {
          textDecoration: "none",
          color: "inherit",
        },
        "::-webkit-scrollbar": { width: "4px", height: "4px" },
        "::-webkit-scrollbar-track": {
          boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        },
        "::-webkit-scrollbar-thumb": {
          background: "#9A9A9A",
          borderRadius: "30px",
        },
        // "*": {
        //   scrollbarWidth: "thin",
        //   scrollbarColor: "#9A9A9A transparent",
        // },
      },
    },
  },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 960,
  //     lg: 1280,
  //     xl: 1920,
  //   },
  // },
});

export default function GlobalCssOverride(props) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
}
